export enum ConditionMatcherEnum {
  MatchAny,
  MatchAll,
  MatchNone,
}
